"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = connect;
var _atom = require("atom");
var _react = require("react");
var _UniqueId = require("./internal/UniqueId");
var _jsxRuntime = require("react/jsx-runtime");
const nextId = (0, _UniqueId.makeUniqueId)('atomConnect');
function makeConnectedComponent(atomMap, BaseComponent) {
  const fields = Object.keys(atomMap);
  const resets = fields.reduce((acc, field) => {
    acc[`${field}Reset`] = _atom.reset.bind(null, atomMap[field]);
    return acc;
  }, {});
  const swaps = fields.reduce((acc, field) => {
    acc[`${field}Swap`] = _atom.swap.bind(null, atomMap[field]);
    return acc;
  }, {});
  const displayName = `ConnectedAtoms(${fields.join(',')})(${BaseComponent.displayName})`;
  class ConnectedAtoms extends _react.Component {
    constructor() {
      super();
      this.id = nextId();
      this.handlers = fields.reduce((acc, field) => {
        const atom = atomMap[field];
        const handler = this.handleUpdate.bind(this, atom, field);
        (0, _atom.watch)(atom, handler);
        acc[field] = handler;
        return acc;
      }, {});
      this.state = fields.reduce((initialState, field) => {
        initialState[field] = (0, _atom.deref)(atomMap[field]);
        return initialState;
      }, {});
    }
    componentWillUnmount() {
      if (!this.handlers) {
        return;
      }
      fields.forEach(field => {
        (0, _atom.unwatch)(atomMap[field], this.handlers[field]);
      });
      this.handlers = null;
    }
    handleUpdate(atom, field) {
      this.setState({
        [field]: (0, _atom.deref)(atom)
      });
    }
    render() {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(BaseComponent, Object.assign({}, this.props, this.state, resets, swaps));
    }
  }
  ConnectedAtoms.displayName = displayName;
  ConnectedAtoms.WrappedComponent = BaseComponent;
  return ConnectedAtoms;
}
function enforceHasDependencies(keys) {
  if (keys.length > 0) {
    return keys;
  }
  throw new Error('expected `atomMap` to contain at least one atom but found none');
}
function enforceIsAtom(field, value) {
  if ((0, _atom.isAtom)(value)) {
    return value;
  }
  throw new Error(`expected \`atomMap["${field}"]\` to be an \`Atom\` but got \`${value}\``);
}
function connect(atomMap) {
  const keys = enforceHasDependencies(Object.keys(atomMap));
  keys.forEach(field => enforceIsAtom(field, atomMap[field]));
  return makeConnectedComponent.bind(null, atomMap);
}
module.exports = exports.default;